import React from 'react';
import { AlertCircle } from 'lucide-react';

interface Props {
  show: boolean;
}

export const DirtyStateBanner: React.FC<Props> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="bg-amber-50 border-l-4 border-amber-500 p-3 mb-4 rounded">
      <div className="flex items-center gap-2">
        <AlertCircle className="h-5 w-5 text-amber-600 flex-shrink-0" />
        <p className="text-sm text-amber-800">
          Map has unsaved edits — the report below reflects the last computed state. Press
          RECOMPUTE to update it.
        </p>
      </div>
    </div>
  );
};